export enum FormProcessNotificationType {
  Defer = 'Defer',
}
